import { UpdateFieldComponent } from '../update-field/update-field.component';
import { ITriggerConfig } from './shared-action-configurations';

const capitaliseFirstChar = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

export class InveniasActionConfigurations {
  private static receivedFromSignatureConfig: ITriggerConfig = {
    id: 'post-ReceivedFromSignature',
    title: (signatureName: string) => `Received from ${capitaliseFirstChar(signatureName)} actions`,
    description: (signatureName: string) => `Actions taken when a document is received from ${capitaliseFirstChar(signatureName)}`,
    actions: {
      [UpdateFieldComponent.NAME]: (UpdateFieldComponent.IUpdateFieldConfig = {
        showDateSentOption: false,
        showDateSavedOption: false,
        showDocusignOption: true,
      }),
    },
  };

  private static signatureSentConfig: ITriggerConfig = {
    id: 'post-SendForSignature',
    title: (signatureName: string) => `Send/Edit in ${capitaliseFirstChar(signatureName)} actions`,
    description: (signatureName: string) => `Actions taken when a document is sent to ${capitaliseFirstChar(signatureName)}`,
    actions: {
      [UpdateFieldComponent.NAME]: (UpdateFieldComponent.IUpdateFieldConfig = {
        showDateSentOption: true,
        showDateSavedOption: false,
        showDocusignOption: false,
      }),
    },
  };

  static triggerConfigs: ITriggerConfig[] = [
    InveniasActionConfigurations.receivedFromSignatureConfig,
    InveniasActionConfigurations.signatureSentConfig,
  ];
}
